export default __webpack_public_path__ + "static/media/dsstest12.7fb68221.jpg";